import React from "react";
import Table from "../../../Common/Table";
import { makeStyles } from "@material-ui/core/styles";

import commonStyles from "../../../../static/styles/common";
import TableFields from "../../../../constants/DriverAccounting/SettlementProcesses/TableFields.json";
import {
  getPath,
  getReadableDate,
  getReadableDateTime,
} from "../../../../utils";
import BlankState from "../../../Common/BlankState";
import Permission from "../../../Common/Permission";
import MenuNames from "../../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../../constants/Menu/MenuActionsMappings";

const useStyles = makeStyles((theme) => ({
  ...commonStyles.tableListStyles,
  pill: { ...commonStyles.pill },
}));

const SettlementProcessesList = (props) => {
  const classes = useStyles();
  const { settlementProcessesList, handleTriggerNextEventClick } = props;
  const allActions = MenuActionsMappings[MenuNames.DRIVER_ACCOUNTING];

  const getFieldValue = (process, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            requiredPerms={[allActions.SETTLEMENT_PROCESS_WRITE]}
            notAllowedText="No Permitted Acion"
          >
            <span
              onClick={() => handleTriggerNextEventClick(process.id)}
              className={"edit-options cursor-pointer"}
            >
              Trigger Next Event
            </span>
          </Permission>
        );
      case "start_date":
      case "end_date":
        return getReadableDate(process[key]);
      case "created_at":
      case "updated_at":
        return getReadableDateTime(process[key]);
      default:
        return process[key];
    }
  };

  return (
    <Permission
      requiredPerms={[allActions.SETTLEMENT_PROCESS_LIST]}
      notAllowedText="You don't have permissions to view the list."
    >
      {getPath(settlementProcessesList, "length", -1) > 0 ? (
        <Table
          list={settlementProcessesList}
          getFieldValue={getFieldValue}
          fields={TableFields}
        />
      ) : (
        <BlankState />
      )}
    </Permission>
  );
};

export default SettlementProcessesList;
